// extracted by mini-css-extract-plugin
module.exports = {"alarm_close":"modal_alarm_close__dDp9R","alarm_modal":"modal_alarm_modal__2hfiM","alarm_modal_lg":"modal_alarm_modal_lg__16j4L","alarm_modal_bg":"modal_alarm_modal_bg__3ldfz"};